import React, { useState, useRef } from 'react';
import { Popup } from 'devextreme-react/popup';
import DataGrid, { DataGridTypes, Column, Editing, Toolbar, Item } from 'devextreme-react/data-grid';
import TextBox from 'devextreme-react/text-box';
import DateBox from 'devextreme-react/date-box';
import SelectBox from 'devextreme-react/select-box';
import Button from 'devextreme-react/button';

interface SalaryDetail {
  temp_id: string;
  pay_detail_id: number;
  item_id: string;
  amount: number;
  notes?: string;
}

interface SalaryRow {
  employee_id: string;
  start_date: string;
  pay_type: string;
  pay_detail_id: number;
  details: SalaryDetail[];
}

const EditSalaryPopup = ({
  data,
  onClose,
  expenseItems,
  payTypes,
  randomMode
}: {
  data: SalaryRow;
  onClose: (data: SalaryRow | null) => void;
  expenseItems: { name: string; value: string }[];
  payTypes: { name: string; value: string }[];
  randomMode: boolean;
}) => {
  const [local, setLocal] = useState<SalaryRow>(data);
  const detailGridRef = useRef<any>(null);

  return (
    <Popup
      visible={true}
      title="Salary Editor"
      width={850}
      height={600}
      onHiding={() => onClose(null)}
    >
      <div style={{ padding: 10 }}>
        <div className="box" style={{ marginBottom: 15 }}>
            <div style={{ display: 'flex', gap: 10 }}>
                <TextBox value={local.employee_id} readOnly width={250} />
                <DateBox
                value={local.start_date || undefined}
                onValueChanged={(e) => setLocal({ ...local, start_date: e.value })}
                disabled={randomMode}
                width={150}
                />
                <SelectBox
                items={payTypes}
                value={local.pay_type}
                displayExpr="name"
                valueExpr="value"
                onValueChanged={(e) => setLocal({ ...local, pay_type: e.value })}
                disabled={randomMode}
                width={200}
                />
            </div>
        </div>


        <div style={{ marginTop: 15 }}></div>

        <div className="box" style={{ marginBottom: 15 }}>
            <DataGrid
            ref={detailGridRef}
            dataSource={local.details}
            keyExpr="temp_id"
            showBorders
            disabled={randomMode}
            onRowInserting={(e) => {
                e.data.temp_id = `${local.pay_detail_id}_${local.details.length + 1}`;
            }}
            >
            <Editing allowAdding={!randomMode} allowDeleting={!randomMode} allowUpdating={!randomMode} mode="row" useIcons />
            <Toolbar>
                <Item location="before">
                <Button
                    icon="add"
                    text="Add"
                    type="default"
                    stylingMode="contained"
                    onClick={() => detailGridRef.current?.instance.addRow()}
                    disabled={randomMode}
                />
                </Item>
                <Item location="before">
                <Button
                    text="Save"
                    type="success"
                    stylingMode="contained"
                    onClick={() => onClose(local)}
                />
                </Item>
            </Toolbar>

            <Column
                dataField="item_id"
                caption="Item"
                lookup={{
                dataSource: expenseItems,
                valueExpr: 'value',
                displayExpr: 'name'
                }}
            />
            <Column
                dataField="amount"
                caption="Amount"
                dataType="number"
                alignment="right"
                format={{ type: 'fixedPoint', precision: 2 }}
            />
            <Column dataField="notes" caption="Notes" />
            </DataGrid>
        </div>
      </div>
    </Popup>
  );
};

export default EditSalaryPopup;
